import React, {useEffect, useRef} from 'react'
import {Transformer} from 'react-konva'

const SelectionTransformer = ({selection}) => {
    const trRef = useRef(null)

    useEffect(() => {
        const layer = trRef.current?.getLayer()
        if (!layer) return
        const nodes = selection.nodeIds.map((id) => layer.findOne(`#${id}`)).filter(Boolean)
        trRef.current.nodes(nodes)
        layer.batchDraw()
    }, [selection])

    return <Transformer ref={trRef} rotateEnabled resizeEnabled />
}

export default SelectionTransformer
